import { render, staticRenderFns } from "./Localize.vue?vue&type=template&id=4450ca54"
import script from "./Localize.vue?vue&type=script&setup=true&lang=js"
export * from "./Localize.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports